import { render } from "./Contactus.vue?vue&type=template&id=026e522a&scoped=true"
import script from "./Contactus.vue?vue&type=script&lang=js"
export * from "./Contactus.vue?vue&type=script&lang=js"

import "./Contactus.vue?vue&type=style&index=0&id=026e522a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\satish\\Desktop\\WEBDEV\\assignment\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-026e522a"]])

export default __exports__